import React from "react";

interface PartnerLogosSectionProps {
  logos: string[];
}

const benefits = [
  {
    icon: "🚀",
    title: "Get Discovered",
    desc: "CORAA routes corporate bookings directly to verified NPOs, focus on impact let us do the GTM.",
  },
  {
    icon: "⏱️",
    title: "Save Time",
    desc: "No more chasing.CORAA automates follow-ups, logistics, and reporting.",
  },
  {
    icon: "💰",
    title: "Grow Revenue",
    desc: "GIVF opens new opportunities for corporate access, scale, and repeat engagement.",
  },
];

const PartnerLogosSection: React.FC = () => {
  const orgs = [
    {
      org_name: "Elixir Foundation",
      website: "https://elixirindia.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/98beca66-2e11-495f-8e9e-b1bd5e689186/profile/0.09108920374385998.png",
    },
    {
      org_name: "Way For Life",
      website: "https://wayforlife.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/34036163-67c7-4b7b-94b6-7ff60422dbb8/profile/0.21371773770869917.png",
    },
    {
      org_name: "Funsmart Knowledge Solution Foundation",
      website: null,
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/e4c0b904-b9cc-48a1-a027-d7d2ebadae08/profile/0.1818670639060158.jpg",
    },
    {
      org_name: "Skrap",
      website: "https://www.skrap.in/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/4f40baee-1c49-44c7-a6e1-35a51c132de8/profile/0.5554680739531821.png",
    },
    {
      org_name: "Vedanshi Foundation",
      website: "https://vedanshifoundation.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/aedc406a-d64a-4690-9a1c-7adee1796e11/profile/0.807482062284804.png",
    },
    {
      org_name: "Youth For Seva",
      website: "https://www.youthforseva.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/d791b83b-d3c2-4f6e-a552-020046536e85/profile/0.032874790360646555.png",
    },
    {
      org_name: "Smile Train India",
      website: "https://donate.smiletrainindia.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/24d64c75-0e13-4f2c-bfe3-8b07f8c18b01/profile/0.23635199579668442.png",
    },
    {
      org_name: "Unnati Balgram",
      website: null,
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/596a3a49-6cd3-4bd5-b5be-34debc76367b/profile/0.914601453308092.jpeg",
    },
    {
      org_name: "Chip Mumbaiu",
      website: "https://www.chipngo.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/ea0541fd-9c7d-41f8-9d3b-605754457936/profile/0.43773109037536684.jpeg",
    },
    {
      org_name: "Ride For a Cause",
      website: "https://rideforcauserfc.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/d8cb57c0-9db6-4f70-9276-0d8a470618c3/profile/0.2737155903663866.png",
    },
    {
      org_name: "Smitam NGO",
      website: "https://smitam.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/9d5a72b4-9204-4819-8fc3-8f8a6e3f1fda/profile/0.9142807653854856.png",
    },
    {
      org_name: "Captains Social Foundation",
      website: "https://captains.ngo/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/8de06ed1-79af-41db-ad9b-c43dfe223560/profile/0.5943073681698867.png",
    },
    {
      org_name: "Bhumi NGO",
      website: "https://www.bhumi.ngo/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/d47feca6-ac53-4eb6-954d-77c4c7763dac/profile/0.6061507385983833.svg",
    },
    {
      org_name: "Aashray Foundation",
      website: "https://aashrayngo.co.in/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/34fe0e46-14be-4cb8-acd7-b7aba1b24adc/profile/0.7609924341106875.png",
    },
    {
      org_name: "Renukiran",
      website: "https://www.renukiran.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/b3038cb2-a45e-4b55-ab14-83e8083462c4/profile/0.3326395694070742.webp",
    },
    {
      org_name: "Skrap",
      website: "https://www.skrap.in/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/4f40baee-1c49-44c7-a6e1-35a51c132de8/profile/0.5554680739531821.png",
    },
    {
      org_name: "Vedanshi Foundation",
      website: "https://vedanshifoundation.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/aedc406a-d64a-4690-9a1c-7adee1796e11/profile/0.807482062284804.png",
    },
    {
      org_name: "Youth For Seva",
      website: "https://www.youthforseva.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/d791b83b-d3c2-4f6e-a552-020046536e85/profile/0.032874790360646555.png",
    },
    {
      org_name: "Smile Train India",
      website: "https://donate.smiletrainindia.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/24d64c75-0e13-4f2c-bfe3-8b07f8c18b01/profile/0.23635199579668442.png",
    },
    {
      org_name: "Unnati Balgram",
      website: null,
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/596a3a49-6cd3-4bd5-b5be-34debc76367b/profile/0.914601453308092.jpeg",
    },
    {
      org_name: "Chip Mumbai",
      website: "https://www.chipngo.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/ea0541fd-9c7d-41f8-9d3b-605754457936/profile/0.43773109037536684.jpeg",
    },
    {
      org_name: "Ride For a Cause",
      website: "https://rideforcauserfc.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/d8cb57c0-9db6-4f70-9276-0d8a470618c3/profile/0.2737155903663866.png",
    },
    {
      org_name: "Smitam NGO",
      website: "https://smitam.org/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/9d5a72b4-9204-4819-8fc3-8f8a6e3f1fda/profile/0.9142807653854856.png",
    },
    {
      org_name: "Captains Social Foundation",
      website: "https://captains.ngo/",
      logo_url:
        "https://xwyerbjrltxnhocncvta.supabase.co/storage/v1/object/public/nonprofit-cloud/8de06ed1-79af-41db-ad9b-c43dfe223560/profile/0.5943073681698867.png",
    },
  ];
  const logos = orgs.concat(orgs);
  return (
    <section
      className="py-20 bg-[#0d1927] text-white relative overflow-hidden"
      id="for-nonprofits"
    >
      <div className="absolute inset-0 pointer-events-none opacity-10 bg-[url('/images/confetti.svg')] bg-cover bg-center" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-violet-500 to-blue-500 text-white text-xs px-4 py-1 rounded-full font-semibold shadow animate-bounce">
            <svg
              className="w-4 h-4 mr-1"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4v16m8-8H4"
              />
            </svg>
            Nonprofit Opportunity
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight text-white drop-shadow-xl">
            Join{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-500">
              GIVF & CORAA
            </span>{" "}
            as a Verified Nonprofit
          </h2>
          <p className="text-white max-w-2xl mx-auto text-lg">
            Get discovered by corporates, automate reporting, and unlock new
            revenue streams, with zero paperwork hassle.
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-8 mb-12">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="flex-1 flex flex-col items-center rounded-2xl shadow-xl p-8 mx-2 bg-white/90 text-gray-900 relative overflow-hidden"
              style={{ minWidth: 260 }}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-violet-400 to-blue-400 mb-4 text-3xl shadow-lg">
                <span role="img" aria-label={item.title}>
                  {item.icon}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-2 drop-shadow-lg">
                {item.title}
              </h3>
              <p className="text-base font-medium mb-2 drop-shadow-sm">
                {item.desc}
              </p>
              {/* Sparkle effect */}
              <span className="absolute left-4 top-4 animate-pulse text-yellow-300 text-2xl">
                ✨
              </span>
              <span className="absolute right-4 bottom-4 animate-pulse text-blue-200 text-2xl">
                🌟
              </span>
            </div>
          ))}
        </div>
        {/* Logo Carousel */}
        <style>{`@keyframes logo-scroll {0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
        <div className="relative mt-10 overflow-hidden">
          <div
            className="flex gap-8 items-center py-4 whitespace-nowrap"
            style={{
              animation: "logo-scroll 60s linear infinite",
              width: "max-content",
            }}
          >
            {logos.map((org, idx) => (
              <div
                key={org.org_name + idx}
                className="flex flex-col items-center min-w-[120px] max-w-[140px] mx-2"
              >
                {org.website ? (
                  <a
                    href={org.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white flex items-center justify-center shadow-lg border-2 border-white hover:scale-105 transition-transform">
                      <img
                        src={org.logo_url}
                        alt={org.org_name}
                        className="w-16 h-16 md:w-20 md:h-20 object-contain object-center rounded-full"
                      />
                    </div>
                  </a>
                ) : (
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white flex items-center justify-center shadow-lg border-2 border-white">
                    <img
                      src={org.logo_url}
                      alt={org.org_name}
                      className="w-16 h-16 md:w-20 md:h-20 object-contain object-center rounded-full"
                    />
                  </div>
                )}
                <span className="mt-2 text-xs font-semibold text-white text-center line-clamp-2">
                  {org.org_name}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="text-center mt-8">
          <a
            href="https://calendly.com/vijay-causeconnect/30min?a1=Become%20a%20Verified%20Nonprofit"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-violet-500 to-blue-500 text-white px-10 py-4 rounded-xl font-bold text-lg shadow-lg hover:scale-105 transition-transform duration-200"
          >
            Become a Verified Nonprofit
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnerLogosSection;
